import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Cache } from 'aws-amplify';

/**
 * Provides the current machine for the route. Uses resolved route data first (from URL machineId)
 * so each tab shows the correct machine when multiple machine tabs are open. Falls back to
 * Cache only when not on a /machine/:machineId route (e.g. legacy or external deep links).
 */
@Injectable({ providedIn: 'root' })
export class MachineRouteService {

  constructor() {}

  /**
   * Get the machine for the current route. Prefer route data (from resolver) over shared Cache
   * so multiple tabs with different machineIds don't overwrite each other.
   * Walks the route tree so it works regardless of nesting depth.
   */
  getMachine(route: ActivatedRoute): Record<string, unknown> | null {
    const fromRoute = this.getMachineFromRouteTree(route);
    if (fromRoute) {
      return fromRoute as Record<string, unknown>;
    }
    return Cache.getItem('selected_machine');
  }

  /**
   * Find machine in route data by walking the route tree (pathFromRoot).
   * Resilient to route structure changes.
   */
  private getMachineFromRouteTree(route: ActivatedRoute): Record<string, unknown> | null {
    let current: ActivatedRoute | null = route;
    while (current) {
      const data = current.snapshot.data['machine'];
      if (data) {
        return data as Record<string, unknown>;
      }
      current = current.parent;
    }
    return null;
  }
}
